import { Chip, type ChipProps } from "@mui/material";

const COLORS: Record<string, ChipProps["color"]> = {
  ACTIVE: "success",
  ARCHIVED: "default",
  SUSPENDED: "warning",
  INACTIVE: "default",
  INVITED: "info",
  LEFT: "default",
};

export function StatusChip({ value }: { value: string }) {
  return (
    <Chip
      size="small"
      color={COLORS[value] ?? "default"}
      variant={value === "ACTIVE" ? "filled" : "outlined"}
      label={value}
    />
  );
}
